import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  createCorporation,
  editCorporation,
  showCorporation,
} from '~/config/routes';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';
import { CorporationProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Corporation() {
  return (
    <CorporationProvider>
      <Switch>
        <Route
          exact
          path={createCorporation.spec}
          render={(props) => (
            <>
              <Can I="new" a="Corporations">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Corporations">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editCorporation.spec}
          render={(props) => (
            <>
              <Can I="edit" a="Corporations">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="Corporations">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showCorporation.spec}
          render={(props) => (
            <>
              <Can I="show" a="Corporations">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Corporations">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="Corporations">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Corporations">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </CorporationProvider>
  );
}
export default Corporation;
